<template>
  <!-- 关于我们数字滚动组件 -->
  <div style="display: inline-block; position: relative">
    <div
      v-for="(item, index) of list"
      :key="index"
      :style="`position: absolute;top:${
        position === index ? '0' : (index - position) * 80
      }px;`"
    >
      {{ item }}
    </div>
    <div
      :id="list.length"
      :style="`transition: all 0.2s;transform: translateY(${
        list.length === position ? '0' : '80px'
      }) ;`"
    >
      {{ num }}
    </div>
  </div>
</template>

<script>
export default {
    name:'scrollNumber',
  props: {
    num: {
      type: [String, Number],
      default: 0,
    },
  },
  data() {
    return {
      list: ["", "", "", "", "", ""],
      position: 0,
    };
  },
  methods: {},
  mounted() {
    var str = String(this.num);
    var list = ["", "", "", "", "", ""];
    for (let i = 0; i < str.length; i++) {
      list[0] += "0";
      list[1] += "2";
      list[2] += "4";
      list[3] += "5";
      list[4] += "6";
      list[5] += "7";
    }
    this.list = list;
    let timer = setInterval(() => {
      //需要定时执行的代码
      this.position += 0.5;
      if (this.position > list.length) {
        this.position = list.length;
        clearTimeout(timer);
      }
    }, 50);
  },
};
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/scrollNumber/scroll-number.vue